import * as angular from "angular";
import {IController, IQService, IScope, ITimeoutService} from "angular";
import * as _ from "lodash";
import {ServiceAreasServiceType} from "../../../service-areas/angular/types/service-areas-service.type";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {QuickFilterContextService} from "../../../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ResourcesService} from "../../services/resources-service.service";
import {DeliveriesDialogService} from "../../../deliveries/services/deliveries-dialog-service.service";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {RouteRequestsService} from "../../../routes/services/routes-requests.service";
import {LeanPlanningAlertsService} from "../../../lean-planning/services/lean-planning-alerts.factory";
import {LeanPlanningDialogService} from "../../../lean-planning/services/lean-planning-dialogs-service.factory";
import {LeanPlanningRequestsService} from "../../../lean-planning/services/plan-requests.factory";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {TaskModel} from "../../../tasks/models/task.model";

export class resourcesGanttViewCtrl implements IController {

  from: any;
  to: any;
  resources: any;
  sortType: any;
  serviceAreaIds: any;
  branchIds: any;
  isActive: boolean;
  viewType: string;
  agentSkills: string[];
  allowBranchSelect: boolean;
  selectedQuickFilterId?: string;
  dateRangeTemplateType?: DateRangeTemplateType;

  public pageName: string;
  public siteId: any;
  public routesRef: any;
  public taskActions: any;
  public tasksRef: any;
  public limit: any;
  public offset: any;
  public viewTypes: any;
  public mainResources: any;
  public routes: any;
  public displayedResources: any;
  public selectedResources: any;
  public routesRefList: any;
  public tasksRefList: any;
  public tasks: any;
  public canCreate: boolean;
  public canUpdate: boolean;
  public canDelete: boolean;
  public filtersConfig: any;
  public pagenationPages: any;
  public allocations: any;

  /* @ngInject */
  constructor(private resourcesService: ResourcesService, private IAMPermissions, private splitService, private commonsService: CommonsService,
              private TimelineService, private $timeout: ITimeoutService, private $state, private commonsDialogService: CommonsDialogService, private $scope: IScope,
              private deliveriesService: DeliveriesService, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private leanPlanningRequestsService: LeanPlanningRequestsService,
              private $log, private $q: IQService, private moment, private routesService: RoutesService, private leanPlanningDialogService: LeanPlanningDialogService,
              private routeRequestsService: RouteRequestsService, private $planningRoutes, private $task, private bringozLoaderService: BringozLoaderService, private quickFilterContextService: QuickFilterContextService,
              private leanPlanningAlertsService: LeanPlanningAlertsService, private $delivery, private deliveriesDialogService: DeliveriesDialogService, private confirmDialogService: ConfirmDialogService, private viewFilterSettingsService: ViewFilterSettingsService) {
    this.pageName = this.$state.current.name;
  }


  $onInit() {
    this.siteId = this.splitService.getSiteId();
    this.routesRef = this.$planningRoutes();
    this.taskActions = [
      {key: 'ASSIGN_ROUTE', name: 'Assign Route', icon: 'assign', permission: 'planning.routes.update'},
      {key: 'RESET_ROUTE', name: 'Reset Route', icon: 'reset', permission: 'planning.routes.update'}
    ];
    this.tasksRef = this.$task();

    this.limit = 20;
    this.offset = 0;

    this.viewTypes = ['day', 'week', 'month'];

    this.mainResources = []; // All Resources
    this.routes = [];
    // ctrl.resources - for queries and
    this.displayedResources = []; // the displayed resources in selected pagination page
    this.selectedResources = []; // the selected resources from dropdown

    this.routesRefList = {};
    this.tasksRefList = {};

    this.tasks = [];

    this.canCreate = this.IAMPermissions.hasPermission('fleetManagement.allocations.create');
    this.canUpdate = this.IAMPermissions.hasPermission('fleetManagement.allocations.update');
    this.canDelete = this.IAMPermissions.hasPermission('fleetManagement.allocations.delete');

    this.filtersConfig = {
      queryString: undefined,
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.dateRangeTemplateType ? this.dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType) :
        ((this.from && this.to) ? {
          dateStart: this.from,
          dateEnd: this.to
        } : this.dateRangeTimeFiltersService.thisCalendarWeek()),
      includeFilters: this.allowBranchSelect ?
        [SiteFiltersType.dateRangeTemplateType, SiteFiltersType.branchIds, SiteFiltersType.serviceAreaIds, SiteFiltersType.agentSkills, SiteFiltersType.isActive] :
        [SiteFiltersType.dateRangeTemplateType, SiteFiltersType.serviceAreaIds, SiteFiltersType.agentSkills, SiteFiltersType.isActive],
      bringozFilters: {
        [SiteFiltersType.dateRangeTemplateType]: this.dateRangeTemplateType,
        [SiteFiltersType.branchIds]: this.branchIds || [],
        [SiteFiltersType.serviceAreaIds]: [],
        [SiteFiltersType.serviceAreasServiceTypes]: [ServiceAreasServiceType.Planning],
        [SiteFiltersType.agentSkills]: this.agentSkills,
        [SiteFiltersType.isActive]: this.isActive
      }
    }

    if (!this.viewType) {
      this.viewType = 'week'
    }

    if (this.resources.length) {

      if (!this.sortType) {
        this.sortType = 'asc'; // asc/desc
      }
      this.resources = _.orderBy(this.resources, ['name'], [this.sortType]);
      this.mainResources = angular.copy(this.resources);
      this._setViewResources(this.resources);
    }
  }

  $onChanges(changes) {
    if (changes.from && !changes.from.isFirstChange || changes.to && !changes.to.isFirstChange) {
      this.filtersConfig.range = {dateStart: this.from, dateEnd: this.to};
    }
  }

  $onDestroy() {
    this._destroyRoutesBindings(undefined);
  }

  // ******************************
  //        Public methods
  // ******************************

  rangeChanged(range) {
    if (!_.isUndefined(range)) {
      this.filtersConfig.range = range;

      if (this.selectedQuickFilterId && range.type !== this.filtersConfig.bringozFilters.dateRangeTemplateType) {
        this.selectedQuickFilterId = undefined;
      }

      this.filtersConfig.bringozFilters.dateRangeTemplateType = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type;
      this._setViewData();
      this._setStateParams();
    }
  }

  onChangeViewType(viewType) {
    if (viewType !== this.viewType) {
      this.viewType = viewType;
      this.filtersConfig.range = this._getRangeByViewType(viewType);

      this._setViewData();
      this._setStateParams();
    }
  }

  onSortTypeChange(sortType) {
    this.sortType = sortType;

    this.offset = 0;
    this.resources = _.orderBy(this.resources, ['name'], [this.sortType]);
    this.mainResources = angular.copy(this.resources);
    this._setViewResources(this.resources);
  }

  onDateRangeBrowse(isNext) {

    var difference = this.moment(this.moment(this.filtersConfig.range.dateEnd).startOf('day').valueOf()).diff(this.filtersConfig.range.dateStart),
      duration = this.moment.duration(difference, 'milliseconds'),
      days = Math.round(duration.asDays()) || 1;

    var range = {
      dateStart: isNext ? this.moment(this.filtersConfig.range.dateStart).add(days, 'days').valueOf() : this.moment(this.filtersConfig.range.dateStart).subtract(days, 'days').valueOf(),
      dateEnd: isNext ? this.moment(this.filtersConfig.range.dateEnd).add(days, 'days').valueOf() : this.moment(this.filtersConfig.range.dateEnd).subtract(days, 'days').valueOf()
    }
    this.rangeChanged(range);
  }

  onDisplayedResourcesSelect(displayedResources) {
    if (!_.isEqual(displayedResources, this.selectedResources)) {
      this.selectedResources = displayedResources;
      this.offset = 0;

      if (!_.get(displayedResources, 'length')) {
        displayedResources = this.resources;
      }

      this._setViewResources(displayedResources);
    }
  }

  onQueryChange(queryString) {
    this.filtersConfig.queryString = queryString;
    this.offset = 0;

    this.resources = _.filter(this.mainResources, (r) => {
      return !queryString ||
        _.includes(_.toLower(r.name), _.toLower(queryString)) ||
        _.includes(_.toLower(r.agentName), _.toLower(queryString))
    });

    var resourcesRef = this.selectedResources.length ? this.selectedResources : this.resources;
    this._setViewResources(resourcesRef);
  }

  onPaginationChange(pageIndex) {
    this.offset = this.limit * pageIndex;

    var resourcesRef = this.selectedResources.length ? this.selectedResources : this.resources;
    this._setViewResources(resourcesRef);
  }

  onPaginationBrowse(isNext) {
    this.offset = isNext ? (this.offset + this.limit) : (this.offset - this.limit);

    var resourcesRef = this.selectedResources.length ? this.selectedResources : this.resources;
    this._setViewResources(resourcesRef);
  }

  isPaginationItemSelected(pageIndex) {
    return (this.offset / this.limit) === pageIndex;
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.filtersConfig.bringozFilters = filters;
    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);

    if (!!filters.dateRangeTemplateType) {
      this.filtersConfig.range = this.dateRangeTimeFiltersService.getDateRangeFilterByType(filters.dateRangeTemplateType);
    }

    this._setResources();
    this._setStateParams();
  }

  onMoveTask(serviceIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, allocationInstanceId, originalId, resourceId, isBetweenDays, toDate, item, assignServices, resetServices, callback) {
    var serviceIdToMove;
    var isBundle = _.get(serviceIds, 'length') > 1;
    var functionRef = isBundle ? this.deliveriesDialogService.selectService(serviceIds) : this.$q.when(serviceIds[0]);
    functionRef
      .then((service) => {
        serviceIdToMove = _.get(service, 'id') || serviceIds[0];
        if (!!_.get(service, 'id') && isBundle) {

          toOrderedIds = _.filter(toOrderedIds, (taskId) => {
            return !_.includes(_.get(item, 'taskIdList'), taskId) || _.includes(service.taskIdList, taskId);
          })
        }
        return isBetweenDays ? this.deliveriesDialogService.editServiceTimeWindow(serviceIdToMove, toDate) : this.$q.when();
      })
      .then((payload) => {
        return !!_.get(payload, 'service') ? this.deliveriesService.updateService(payload.service, payload.isShouldSendSms) : this.$q.when();
      })
      .then(() => {
        this._editRoutes([serviceIdToMove], fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, allocationInstanceId, originalId, resourceId, assignServices, resetServices, callback)
      })
      .catch((error) => {
        callback(null);
      })
  }

  onTaskChange(id, routeId, serviceTime?, detailedServiceTime?) {
    // var serviceTime = this.moment(notAfter).diff(this.moment(notBefore));

    const payload = {
      detailedServiceTime: detailedServiceTime,
      legacyServiceTime: serviceTime,
      useLegacyServiceTime: !!serviceTime
    }

    this.routesService.updateTaskTimeWindow(routeId, id, payload)
      .then((updatedRoute: any) => {
        let routesCopy = angular.copy(this.routes);
        routesCopy = _.filter(routesCopy, (r) => {
          return r.id !== updatedRoute.id;
        })
        this.routes = _.uniqBy([updatedRoute].concat(routesCopy), 'id');
      })
  }

  onViewService(serviceId) {
    this.bringozLoaderService.on();
    this.$delivery(serviceId).$asyncValue()
      .then((service) => {
        this.deliveriesDialogService.serviceInfo(service);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onRightClickTask(task, $event) {
    this.commonsService.openActionPanel(this.taskActions, $event)
      .then((action: any) => {
        if (_.isEqual(action.key, 'ASSIGN_ROUTE')) {
          this._onAssignRoute(task.routeId, $event)
        }
        if (_.isEqual(action.key, 'RESET_ROUTE')) {
          this._onResetRoute(task.routeId)
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  // ******************************
  //        Private methods
  // ******************************

  _setStateParams() {
    this.$state.go('.', {
      dateRangeTemplateType: this.filtersConfig.bringozFilters.dateRangeTemplateType,
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      isActive: this.filtersConfig.bringozFilters.isActive,
      agentSkills: this.filtersConfig.bringozFilters.agentSkills,
      serviceAreaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      selectedQuickFilterId: this.selectedQuickFilterId
    }, {notify: false, reload: false});
  }

  _createNewRoute(allocationInstanceId, originalId, serviceIds, branchIds) {
    const createRoutePayload = {
      branchIds: branchIds,
      planningResource: {
        allocationInstanceId: allocationInstanceId,
        allocationTimeWindowId: originalId,
        supplyResourceSource: "Allocation"
      },
      serviceIdList: serviceIds
    }
    this.bringozLoaderService.on();
    this.leanPlanningRequestsService.createRoute(createRoutePayload)
      .then((createdRoute) => {
        this.routes = _.concat(this.routes, [createdRoute]);
        this.$timeout(100).then(() => {
          var oldTasksRef = angular.copy(this.tasks);
          var filteredTasks = _.filter(this.tasks, (t) => {
            return !_.includes(createdRoute.id, t.routeId);
          })
          _.forEach(createdRoute.taskListExt, (t) => {
            t.routeId = createdRoute.id;
          })
          this.tasks = _.uniqBy(createdRoute.taskListExt.concat(filteredTasks), 'id');
          // ctrl.tasks = _.uniqBy(createdRoute.taskListExt.concat(ctrl.tasks), 'id');
          this._bindTasks(this.tasks, oldTasksRef);

          // _bindRoutes([createdRoute]);
          // var displayedResourceIds = _.map(ctrl.displayedResources, 'id');
          // _getRoutes(ctrl.filtersConfig.range.dateStart, ctrl.filtersConfig.range.dateEnd, displayedResourceIds, ctrl.filtersConfig.bringozFilters.branchIds, ctrl.filtersConfig.bringozFilters.serviceAreaIds)
          //   .then((routes) =>{
          //     ctrl.routes = routes;
          //
          //     var oldTasksRef = angular.copy(ctrl.tasks);
          //     ctrl.tasks = _.flatMap(routes, 'taskListExt');
          //     _bindTasks(ctrl.tasks, oldTasksRef);
          //   })
        })
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to change route itinerary @planningRoute@onRouteOrderChange', error);
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _setResources() {
    this.offset = 0;
    this.resourcesService.getResources(
      this.filtersConfig.bringozFilters.branchIds,
      undefined,
      this.filtersConfig.bringozFilters.serviceAreaIds,
      this.filtersConfig.bringozFilters.isActive,
      this.filtersConfig.bringozFilters.agentSkills,
    )
      .then((resources: any) => {
        this.resources = _.orderBy(resources, ['name'], [this.sortType]);
        this.mainResources = angular.copy(this.resources);
        this._setViewResources(this.resources)
      })
  }

  _getRangeByViewType(viewType) {
    var range = {dateStart: undefined, dateEnd: undefined};

    if (viewType === 'day') {
      range.dateStart = this.moment().startOf('day').valueOf();
      range.dateEnd = this.moment().endOf('day').valueOf()
    } else if (viewType === 'week') {
      range.dateStart = this.moment().startOf('week').valueOf();
      range.dateEnd = this.moment().endOf('week').valueOf()
    } else if (viewType === 'month') {
      range.dateStart = this.moment().startOf('month').valueOf();
      range.dateEnd = this.moment().endOf('month').valueOf()
    }
    return range;
  }

  _setViewResources(resources) {
    this.pagenationPages = _.range(Math.ceil(_.get(resources, 'length', 0) / this.limit));
    this.displayedResources = _.filter(resources, (r, index) => {
      return index + 1 > this.offset && index + 1 <= this.offset + this.limit;
    });

    this._setViewData();
  }

  _setViewData() {

    this._destroyTasksBinding(_.map(this.tasks, 'id'));

    this.allocations = [];
    this.routes = [];
    this.tasks = [];

    const displayedResourceIds = _.map(this.displayedResources, 'id');
    if (!displayedResourceIds?.length) {
      return;
    }

    var allocations = this._getAllocationsByResourceIds(this.filtersConfig.range.dateStart, this.filtersConfig.range.dateEnd, displayedResourceIds, this.filtersConfig.bringozFilters.branchIds, this.filtersConfig.bringozFilters.serviceAreaIds);
    var routes = this._getRoutes(this.filtersConfig.range.dateStart, this.filtersConfig.range.dateEnd, displayedResourceIds, this.filtersConfig.bringozFilters.branchIds, this.filtersConfig.bringozFilters.serviceAreaIds, false);

    if (this.displayedResources.length) {
      this.$q.all([allocations, routes])
        .then((res) => {
          this.allocations = res[0];
          this.routes = res[1];
          this.tasks = _.flatMap(res[1], 'taskListExt');

          this._bindTasks(this.tasks);

          // _destroyRoutesBindings();
          // ctrl.routesRefList = {};
          //
          // _bindRoutes(ctrl.routes);
        })
    } else {
      this.allocations = [];
      this.routes = [];
      this.tasks = [];
    }

  }

  _getAllocationsByResourceIds(from, to, resourceIds, branchIds, serviceAreaIds) {
    return this.resourcesService.getAllocationsTimeWindows(from, to, resourceIds, branchIds, serviceAreaIds)
      // .then((allocations) => {
      //    ctrl.allocations = allocations || [];
      // })
      .catch((error) => {
        this.$log.error('Failed to get allocations', error)
      })
  }

  _getRoutes(from, to, resourceIds, branchIds, serviceAreaIds, doTimeout) {
    var query = {
      from: from,
      to: to,
      expandServices: false,
      expandTasks: false,
      expandTasksExt: true,
      branchIds: branchIds,
      areaIds: serviceAreaIds,
      allocationIds: resourceIds,
      supplyResourceSource: 'Allocation',
      statusGroup: 'Active'
    }
    var timeout = doTimeout ? 5000 : 0;

    this.bringozLoaderService.on();
    return this.$timeout(timeout)
      .then(() => {
        return this.routesRef.$getAll(query)
      })
      .then((ids) => {
        return this.routesRef.$asyncValues(ids);
      })
      .catch((error) => {
        this.$log.error('Failed to get allocations', error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })


    // return routesRef.$getAll(query)
    //   .then((ids) => {
    //     return routesRef.$asyncValues(ids);
    //   })
    //   .catch((error) => {
    //     $log.error('Failed to get allocations', error)
    //   })
    //   .finally(() => {
    //     bringozLoaderService.off();
    //   })
  }

  _onAssignRoute(routeId, event) {
    this.leanPlanningDialogService.manualAssignRoute(event, routeId)
      .then((payload) => {
        this._assignAgent(routeId, payload.agentId, payload.assignServices);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  _assignAgent(routeId, agentId, assignServices) {
    this.bringozLoaderService.on();
    this.leanPlanningRequestsService.assignRouteToAgent(routeId, agentId, assignServices)
      .then((assignedRoute) => {
        this.leanPlanningAlertsService.assignSuccess();

        const updatedRouteIndex = _.findIndex(this.routes, (r: any) => {
          return r.id === routeId
        })
        if (updatedRouteIndex > -1) {
          const routesCopy = angular.copy(this.routes);
          routesCopy[updatedRouteIndex].status = 'Assigned';
          routesCopy[updatedRouteIndex].updatedTime = this.moment().valueOf();
          this.routes = routesCopy;
        }
      })
      .catch((error) => {
        this.leanPlanningAlertsService.assignError();
        this.$log.error('Failed to assign route to driver @planningRoutesTable@onAssignRoute', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _onResetRoute(routeId) {
    this.confirmDialogService.confirm('Reset Route', 'Are you sure you want to reset?')
      .then(() => {
        this._resetRoute(routeId);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  _resetRoute(routeId) {
    this.bringozLoaderService.on();
    this.routeRequestsService.resetRoutes([routeId])
      .then((updatedRoute) => {
        // ctrl.routes = _.uniqBy([updatedRoute].concat(ctrl.routes), 'id');
        this.leanPlanningAlertsService.resetSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.resetError();
          this.$log.error('Failed to reset routes @planningRoutes@onResetRoutes', error);
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _editRoutes(serviceIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, allocationInstanceId, originalId, resourceId, assignServices, resetServices, callback) {
    var payload = this.TimelineService.getMovedTaskPayload(serviceIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds);
    // callback(null);
    this.bringozLoaderService.on();
    this.leanPlanningRequestsService.editRoutes(payload, assignServices, resetServices)
      .then((updatedRoutes) => {

        this.routes = _.filter(_.uniqBy(updatedRoutes.concat(this.routes), 'id'), (r: any) => {
          return !_.isEqual(r.status, 'Deleted')
        })

        var updatedTasks = _.flatMap(updatedRoutes, 'taskListExt');

        //TODO Patch for server side bug in endpoint
        _.forEach(updatedTasks, (t) => {
          var taskRouteRef = _.find(this.routes, (r) => {
            return _.includes(r.taskIdListExt, t.id);
          })
          t.updatedAt = this.moment().valueOf();
          if (taskRouteRef) {
            t.routeId = taskRouteRef.id;
          }
        })

        var oldTasksRef = angular.copy(this.tasks);
        var filteredTasks = _.filter(this.tasks, (t) => {
          return !_.includes(_.map(updatedRoutes, 'id'), t.routeId);
        });
        // ctrl.tasks = updatedTasks.concat(newTasksList);
        this.tasks = updatedTasks.concat(filteredTasks);
        this._bindTasks(this.tasks, oldTasksRef);
        this.leanPlanningAlertsService.updateSuccess();

        // var updatedRouteIds = _.get(updatedRoutes, 'id');
        // var oldTasksRef = angular.copy(ctrl.tasks);
        // oldTasksRef = _.filter(oldTasksRef, (t) => {
        //   return !_.includes(updatedRouteIds, t.routeId) || _.includes(_.flatMap(updatedTasks, 'id'), t.id);
        // })
        // ctrl.tasks = _.uniqBy(updatedTasks.concat(oldTasksRef), 'id');
        // _bindTasks(ctrl.tasks, oldTasksRef);
        // leanPlanningAlertsService.updateSuccess();


        //check for duplicates
        // var routesCopy = angular.copy(ctrl.routes);
        // routesCopy = updatedRoutes.concat(routesCopy);
        // ctrl.routes = _.uniqBy(routesCopy, 'id');

        if (!toRouteId) {
          var branchIds;
          var resourceRef = _.find(this.resources, (r) => {
            return r.id === resourceId
          })
          if (resourceRef) {
            branchIds = resourceRef.branchIds;
          }
          this._createNewRoute(allocationInstanceId, originalId, serviceIds, branchIds)
        } else {
          // var displayedResourceIds = _.map(ctrl.displayedResources, 'id');
          // _getRoutes(ctrl.filtersConfig.range.dateStart, ctrl.filtersConfig.range.dateEnd, displayedResourceIds, ctrl.filtersConfig.bringozFilters.branchIds, ctrl.filtersConfig.bringozFilters.serviceAreaIds, true)
          //   .then((routes) => {
          //     ctrl.routes = routes;
          //     ctrl.tasks = _.flatMap(routes, 'taskListExt');
          //   })
        }
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error('Failed to change route itinerary @planningRoute@onRouteOrderChange', error);
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _bindRoutes(routes) {

    if (routes && routes.length) {
      var routeIds = _.map(routes, 'id');
      // this._bindTasks(_.flatMap(routes, 'taskIdListExt'));
      this._bindTaskIds(_.flatMap(routes, 'taskIdListExt'));

      _.forEach(routeIds, (id) => {
        var isInit = true;
        var routeRef = this.$planningRoutes(id);
        this.routesRefList[id] = routeRef;

        routeRef.$bindCtrl(this.$scope, this, id);
        routeRef.$registerOnUpdateHandler(this, (updatedRoute) => {
          if (isInit) {
            isInit = false;
            return;
          }

          if (updatedRoute.status === 'Deleted') {
            this._destroyRoutesBindings([updatedRoute.id]);
            this._destroyTasksBinding(updatedRoute.taskIdListExt);
            return;
          }

          var routeIndexToUpdate = _.findIndex(this.routes, (i: any) => {
            return i.id === updatedRoute.id;
          });
          if (routeIndexToUpdate > -1) {


            if (this.moment(updatedRoute.updatedAt).valueOf() > this.moment(this.routes[routeIndexToUpdate].updatedAt).valueOf()) {


              var oldTaskIdListExtRef = angular.copy(this.routes[routeIndexToUpdate].taskIdListExt);
              var oldTaskListExt = angular.copy(this.routes[routeIndexToUpdate].taskListExt);

              var updatedRouteCopy = angular.copy(updatedRoute);
              updatedRouteCopy.taskListExt = oldTaskListExt;
              this.routes[routeIndexToUpdate] = updatedRouteCopy;

              this._bindTaskIds(updatedRoute.taskIdListExt, oldTaskIdListExtRef);
            }

          } else {
            routeRef.$destroy();
          }
        });
      })

    }
  }

  private _bindTaskIds(updatedTasksIds, oldTasksIds?) {
    const tasks = this.$task().$asyncValues(updatedTasksIds),
      oldTasks = oldTasksIds ? this.$task().$asyncValues(oldTasksIds) : this.$q.when();

    this.$q.all([tasks, oldTasks])
      .then((res) => {
        this._bindTasks(res[0], res[1])
      })
  }

  _bindTasks(updatedTasks, oldTasks?) {
    var ids = _.map(updatedTasks, 'id');
    var oldIds = _.map(oldTasks, 'id');

    if (_.isUndefined(ids)) {
      ids = [];
    }

    if (!oldIds) {
      oldIds = [];
    }

    var taskIdsToAdd = _.difference(ids, oldIds);
    var taskIdsToRemove = _.difference(oldIds, ids);
    var tasksToAdd = _.filter(updatedTasks, (t) => {
      return _.includes(taskIdsToAdd, t.id);
    })

    this.$log.info('TASKS TO ADD', taskIdsToAdd);
    this.$log.info('TASKS TO Remove', taskIdsToRemove);

    this.tasks = _.filter(this.tasks, (t) => {
      return !_.includes(taskIdsToRemove, t.id);
    })
    this._destroyTasksBinding(taskIdsToRemove);

    var filteredTasks = _.filter(tasksToAdd, (t) => {
      return !!t.routeId;
    })
    this.tasks = _.uniqBy(filteredTasks.concat(this.tasks), 'id');
    _.forEach(tasksToAdd, (task: TaskModel) => {

      var taskRef = this.$task(task.id);
      // var isInit = true;
      this.tasksRefList[task.id] = taskRef;
      taskRef.$bindCtrl(this.$scope, this, task.id);

      taskRef.$registerOnUpdateHandler(this.$scope, (updatedTask) => {
        // if (isInit) {
        //   isInit = false;
        //   return;
        // }


        var taskIndexToUpdate = _.findIndex(this.tasks, (t: any) => {
          return t.id === updatedTask.id;
        });

        if (taskIndexToUpdate > -1) {
          if (this.moment(updatedTask.updatedAt).valueOf() > this.moment(this.tasks[taskIndexToUpdate].updatedAt).valueOf()) {
            var tasksCopy = angular.copy(this.tasks);
            tasksCopy[taskIndexToUpdate] = updatedTask
            this.tasks = tasksCopy;
          }
        }

      });

    });


    // tasksRef.$asyncValues(taskIdsToAdd)
    //   .then((tasks) => {
    //     var filteredTasks = _.filter(tasks, (t) => {
    //       return !!t.routeId;
    //     })
    //     ctrl.tasks = _.uniqBy(filteredTasks.concat(ctrl.tasks), 'id');
    //     _.forEach(tasks, (task: TaskModel) => {
    //
    //       var taskRef = $task(task.id);
    //       // var isInit = true;
    //       ctrl.tasksRefList[task.id] = taskRef;
    //       taskRef.$bindCtrl($scope, ctrl, task.id);
    //
    //       taskRef.$registerOnUpdateHandler($scope, (updatedTask) => {
    //         // if (isInit) {
    //         //   isInit = false;
    //         //   return;
    //         // }
    //
    //
    //         var taskIndexToUpdate = _.findIndex(ctrl.tasks, (t) => {
    //           return t.id === updatedTask.id;
    //         });
    //
    //         if (taskIndexToUpdate > -1) {
    //           if (moment(updatedTask.updatedAt).valueOf() > moment(ctrl.tasks[taskIndexToUpdate].updatedAt).valueOf()) {
    //             var tasksCopy = angular.copy(ctrl.tasks);
    //             tasksCopy[taskIndexToUpdate] = updatedTask
    //             ctrl.tasks = tasksCopy;
    //           }
    //         }
    //
    //       });
    //
    //     });
    //   })
  }

  // _getExpandedRoutes(routeId) {
  //   RoutesService.getRoutes([routeId], undefined, true)
  //     .then((expandedRoutes)=> {
  //       var expandedRouteRef = expandedRoutes[0];
  //       var routeIndex = _.findIndex(ctrl.routes, (r) => {
  //         return r.id === expandedRouteRef.id;
  //       })

  //       if (routeIndex > -1) {
  //         var routesCopy = angular.copy(ctrl.routes);
  //         routesCopy[routeIndex] = expandedRouteRef;
  //         ctrl.routes = routesCopy;
  //       }
  //     })
  // }

  _destroyRoutesBindings(ids) {
    _.forEach(ids, (id) => {
      if (this.routesRefList[id]) {
        this.routesRefList[id].$destroy();
        _.unset(this.routesRefList, id);
      }
    });
    if (!ids) {
      _.forOwn(this.routesRefList, (value, key) => {
        _.unset(this.routesRefList, key);
      })
    }

  }


  _destroyTasksBinding(ids) {
    _.forEach(ids, (id) => {
      if (this.tasksRefList[id]) {
        this.tasksRefList[id].$destroy();
        _.unset(this.tasksRefList, id);
      }
      if (!ids) {
        _.forOwn(this.tasksRefList, (value, key) => {
          _.unset(this.tasksRefList, key);
        })
      }
    });
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourcesGanttView', {
    bindings: {
      from: '<',
      to: '<',
      resources: '<',
      sortType: '<?',
      serviceAreaIds: '<',
      branchIds: '<?',
      isActive: '<?',
      viewType: '<?',
      agentSkills: '<?',
      allowBranchSelect: '<?',
      selectedQuickFilterId: '<?',
      dateRangeTemplateType: '<?'
    },
    template: require('./resources-gantt-view.html').default,
    controller: resourcesGanttViewCtrl
  });
